import { MantineDataTable,
    DataTableTokenPagination,
} from '@flexinet/ui-components';
import { Stack } from '@mantine/core';
import { useAllTags } from '../hooks/useAllTags';
import { useTagsTableColumns } from '../hooks/useTagsTableColumns';
import { useRef } from 'react';

export const TagsTable = () => {
    const { visibleItems, loading, nextToken, fetchRecords, isFetchingNextPage, visibleCount } = useAllTags();
    const columns = useTagsTableColumns();
    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack gap="lg">
            <MantineDataTable
                columns={columns}
                records={visibleItems}
                fetching={loading}
                withTableBorder={true}
                onScrollToBottom={fetchRecords}
                scrollViewportRef={scrollViewportRef}
            />
            <DataTableTokenPagination
                loadedCount={visibleCount}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
                isFetchingMore={isFetchingNextPage}
            />
        </Stack>
    );
};
